import useAboutData from "../hooks/useAboutData";
import useRevealText from "../hooks/useRevealText";
import useRotatingSlogan from "../hooks/useRotatingSlogan";

import RotatingSlogan from "../components/RotatingSlogan";
import LittleText from "../components/LittleText";
import PhilosophyDetail from "../components/PhilosophyDetail";
import ThirtyYearsSection from "../components/ThirtyYearsSection";
import ObsessionPromise from "../components/ObsessionPromise";

import Footer from "../../../../components/Footer/Footer";

import "../styles/AboutPage.css";

import ani1 from "../../../../assets/icons/icon_box_dynamic.png";
import ani2 from "../../../../assets/icons/icon_home_dynamic.png";
import ani3 from "../../../../assets/icons/icon_love_dynamic.png";
import diamondIcon from "../../../../assets/icons/diamond.png";
import qualityIcon from "../../../../assets/icons/quality.png";

const SLOGANS = [
    { icon: ani1, text: "Good design doesn’t ask for attention; it earns it." },
    { icon: ani2, text: "Every corner deserves a little love." },
    { icon: ani3, text: "Home isn’t built; it’s curated." },
];

export default function AboutPage() {
    const { data, loading, error } = useAboutData();
    const { item, fade } = useRotatingSlogan(SLOGANS);

    useRevealText(data?.description);

    if (loading) return null; // or Skeleton
    if (error) return <p className="error">{error}</p>;

    return (
        <>

            <div className="about-wrapper">
                {/* HERO */}
                <section className="about-hero" style={{ backgroundImage: `url(${data?.bg_media})` }} >
                    <div className="hero-overlay">
                        <h1>
                            <p
                                className="track_set_hader"
                                dangerouslySetInnerHTML={{
                                    __html: data?.bg_short_desc?.replace(/\{\"\s*\"\}/g, " "),
                                }}
                            />
                        </h1>
                    </div>
                </section>

                {/* SLOGAN */}
                <RotatingSlogan item={item} fade={fade} />

                {/* DESCRIPTION */}
                <LittleText
                    data={data}
                    diamond={diamondIcon}
                    quality={qualityIcon}
                />

                {/* PHILOSOPHY */}
                <PhilosophyDetail data={data} />
            </div>

            {/* OTHER SECTIONS */}
            <ThirtyYearsSection data={data} />
            <ObsessionPromise data={data} />
            <Footer />
        </>
    );
}
